export default {
      id: "help-usage",
      viewBox: "0 0 25 29",
      url: __webpack_public_path__ + "svgsprite.svg#help",
      toString: function () {
        return this.url;
      }
    }